import Colors from '../../styles/colors';

const styles = (theme) => ({
    blueWrapper: {
        backgroundColor: Colors.blue,
    },
    blackWrapper: {
        backgroundColor: Colors.black,
        color: Colors.white,
        paddingTop: 60,
        paddingBottom: 60,
    },
    logoBlock: {
        backgroundColor: Colors.grey,
        height: 136,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            marginTop: 20,
        },
    },
    hr: {
        border: `2px solid ${Colors.black}`,
        marginTop: 0,
        marginBottom: 0,
    },
    title: {
        paddingTop: 5,
        paddingBottom: 8,
    },
    videoRow: {
        paddingLeft: '20%',
        paddingRight: '20%',
        [theme.breakpoints.down('md')]: {
            paddingLeft: 0,
            paddingRight: 0,
        },
    },
    textLink: {
        color: Colors.blueDk,
    },
    socialBlock: {
        width: 44,
        height: 44,
        display: 'inline-flex',
        padding: 10,
        '& svg': {
            color: Colors.white,
        },
        '&:hover': {
            opacity: 0.7,
        },
    },
});
export default styles;
